export var PersonAcademicTitle;
(function (PersonAcademicTitle) {
    PersonAcademicTitle["ProfDrMed"] = "academic_title_prof_dr_med";
    PersonAcademicTitle["ProfDrDr"] = "academic_title_prof_dr_dr";
    PersonAcademicTitle["ProfDr"] = "academic_title_prof_dr";
    PersonAcademicTitle["Prof"] = "academic_title_prof";
    PersonAcademicTitle["None"] = "academic_title_none";
    PersonAcademicTitle["DrMed"] = "academic_title_dr_med";
    PersonAcademicTitle["DrDr"] = "academic_title_dr_dr";
    PersonAcademicTitle["Dr"] = "academic_title_dr";
})(PersonAcademicTitle || (PersonAcademicTitle = {}));
export var PersonRole;
(function (PersonRole) {
    PersonRole["AccountHolder"] = "ACCOUNT_HOLDER";
    PersonRole["UltimateOwner"] = "ULTIMATE_BENEFICIAL_OWNER";
    PersonRole["AuthorizedPerson"] = "AUTHORIZED_PERSON";
    PersonRole["LegalRepresentative"] = "LEGAL_REPRESENTATIVE";
    PersonRole["TaxPartner"] = "TAX_PARTNER";
})(PersonRole || (PersonRole = {}));
export var PersonRoleStatus;
(function (PersonRoleStatus) {
    PersonRoleStatus["Requested"] = "REQUESTED";
    PersonRoleStatus["Active"] = "ACTIVE";
    PersonRoleStatus["Disabled"] = "DISABLED";
})(PersonRoleStatus || (PersonRoleStatus = {}));
export var DataValidityStatus;
(function (DataValidityStatus) {
    DataValidityStatus["VALID"] = "VALID";
    DataValidityStatus["REVALIDATE"] = "REVALIDATE";
    DataValidityStatus["SUBMITTED"] = "SUBMITTED";
    DataValidityStatus["CHANGED"] = "CHANGED";
    DataValidityStatus["EXPIRED"] = "EXPIRED";
})(DataValidityStatus || (DataValidityStatus = {}));
export var CustomerType;
(function (CustomerType) {
    CustomerType["JOINT"] = "JOINT";
    CustomerType["PERSONAL"] = "PERSONAL";
    CustomerType["BUSINESS"] = "BUSINESS";
})(CustomerType || (CustomerType = {}));
export var CustomerStatus;
(function (CustomerStatus) {
    CustomerStatus["Registered"] = "REGISTERED";
    CustomerStatus["Identified"] = "IDENTIFIED";
    CustomerStatus["PendingAcceptance"] = "PENDING_SERVICING_BANK_ACCEPTANCE";
    CustomerStatus["Active"] = "ACTIVE";
    CustomerStatus["Rejected"] = "REJECTED";
    CustomerStatus["DeletionInitiated"] = "DELETION_INITIATED";
    CustomerStatus["Deleted"] = "DELETED";
    CustomerStatus["TerminationRequested"] = "TERMINATION_REQUESTED";
    CustomerStatus["TerminationInitiated"] = "TERMINATION_INITIATED";
    CustomerStatus["Terminated"] = "TERMINATED";
})(CustomerStatus || (CustomerStatus = {}));
//# sourceMappingURL=customer.js.map